import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import WPSitesTable from "../../../shared/components/WPSites/WPSitesTable";

const WPSites = () => {
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">WP Sites</h3>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={3}>
                    <Card>
                        <CardBody>
                            <Link to="/wps/add" className="btn btn-primary">Add Site</Link>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <WPSitesTable/>
            </Row>
        </Container>
    );
}

export default WPSites;
